import { useEffect, useRef } from 'react';
import { Composer, type MicSignal } from '../components/Composer';
import { statusLabel, time } from '@elena/shared';
import { Icon } from '../components/Icon';
import { api } from '../lib/api';
import { useElena } from '../state';

export function Chat({ micSignal }: { micSignal: MicSignal }) {
  const { messages, thinking, setTalk, connection } = useElena();
  const endRef = useRef<HTMLDivElement>(null);

  useEffect(() => endRef.current?.scrollIntoView({ block: 'end' }), [messages.length, thinking]);

  return (
    <div className="page chat">
      <header className="page-head">
        <div>
          <h1>Razgovor</h1>
          <p className="muted">
            Elena pamti razgovor i ono što joj kažeš o sebi. „Hajde da pričamo“ otvara razgovor bez
            dugmeta.
          </p>
        </div>
        <div className="row gap-8">
          <button
            type="button"
            className="btn primary"
            onClick={() => setTalk(true)}
            disabled={connection !== 'online'}
          >
            <Icon name="talk" size={16} /> Pričaj sa mnom
          </button>
          <button type="button" className="btn" onClick={() => void api.reset()}>
            Počni iz početka
          </button>
        </div>
      </header>

      <ol className="transcript" aria-live="polite">
        {messages.length === 0 && (
          <li className="muted empty">Napiši ili reci nešto Eleni da započneš.</li>
        )}
        {messages.map((m) => (
          <li key={m.id} className={`bubble ${m.role}`}>
            <p>{m.text}</p>
            {m.steps && m.steps.length > 0 && (
              <ul className="bubble-steps">
                {m.steps.map((s, i) => (
                  <li key={i} className={`step-${s.status}`}>
                    {s.summary} · {statusLabel[s.status]}
                  </li>
                ))}
              </ul>
            )}
            <span className="bubble-time">{time(m.at)}</span>
          </li>
        ))}
        {thinking && <li className="bubble elena typing">Elena razmišlja…</li>}
      </ol>
      <div ref={endRef} />

      <div className="chat-composer">
        <Composer autoFocus listenSignal={micSignal} />
      </div>
    </div>
  );
}
